import { useAppSelector } from "../redux/hooks";
import { useGetDashboardQuery } from "../redux/services/dashboard";
import { browserTimeZone } from "../utils";

export const useTokensFinished = () => {
  const selectedAccount = useAppSelector((state) => state.user.selectedAccount);
  const accountId = selectedAccount?.accountId;

  const { data } = useGetDashboardQuery(
    {
      accountId: accountId ?? "",
      timezone: selectedAccount?.timezone ?? browserTimeZone,
    },
    { skip: !accountId }
  );

  return {
    isTokensFinished: selectedAccount?.unlimitedTokens
      ? false
      : data?.tokensRemaining < 1,
  };
};
